import { render, staticRenderFns } from "./VPopoverWrapper.vue?vue&type=template&id=fc7d5412&"
import script from "./VPopoverWrapper.vue?vue&type=script&lang=js&"
export * from "./VPopoverWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports